function testId(value: string) {
	return {
		'data-testid': value,
	}
}

export { testId }
